import { render, staticRenderFns } from "./extraRewardAdd.vue?vue&type=template&id=dfa5882a"
import script from "./extraRewardAdd.vue?vue&type=script&lang=js"
export * from "./extraRewardAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfa5882a')) {
      api.createRecord('dfa5882a', component.options)
    } else {
      api.reload('dfa5882a', component.options)
    }
    module.hot.accept("./extraRewardAdd.vue?vue&type=template&id=dfa5882a", function () {
      api.rerender('dfa5882a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/couponExpand/extraRewardAdd.vue"
export default component.exports